module.exports = __webpack_public_path__ + "img/Floatie.42871deb.png";